module.exports = __webpack_public_path__ + "4067dc6b58b7258ac1062ece45bbfe45.svg";